export enum AutopilotCommandEnum {
    Unknown = 'Unknown',
    Initial = 'Initial',
    Takeoff = 'Takeoff',
    Land = 'Land',
    Loiter = 'Loiter',
    ReturnToLaunch = 'ReturnToLaunch',
    SetAltitude = 'SetAltitude',
    SetSpeed = 'SetSpeed',
    ChangeYaw = 'ChangeYaw',
    SetVerticalSpeed = 'SetVerticalSpeed',
    SetWaypoint = 'SetWaypoint',
    ForkRoute = 'ForkRoute',
    JoinRoute = 'JoinRoute',
    Terminate = 'Terminate',
    LaunchParachute = 'LaunchParachute',
    MissionArea = 'MissionArea',
    MissionScan = 'MissionScan',
    SetHome = 'SetHome',
    SetMode = 'SetMode',
    SetArmMode = 'SetArmMode',
    LoadFlightPlan = 'LoadFlightPlan',
    LoadOperation = 'LoadOperation',
    // Starts the main flight plan after a certain time;
    // uses fpName as fp indicator.
    FlightPlanStart = 'FlightPlanStart',
    // Starts a contingency flight plan after a certain time;
    // uses fpName as contingency fp indicator.
    ContingencyPlanStart = 'ContingencyPlanStart',
    LoadFence = 'LoadFence',
    ActivateFence = 'ActivateFence',
    // Selects a route within main flight-plan, uses fpName as contingency fp indicator (optional),
    // label as select indicator and ncl as next label.
    SelectRoute = 'SelectRoute',
    // Selects take-off command from main flight-plan, uses ncl as take-off label.
    SelectTakeOff = 'SelectTakeOff',
    // Selects initial command from contingency flight-plan,
    // uses fpName as contingency fp indicator and ncl as initial label.
    SelectInitial = 'SelectInitial',
    Acknowledge = 'Acknowledge'
}